module.exports = __webpack_public_path__ + "img/soft_4.56ec3e4b.png";